import React, { useState, useRef } from "react";
import { Button, Overlay, Popover } from "react-bootstrap";
import ColorPicker from "react-best-gradient-color-picker";

const PopoverColorPicker = ({ value, onChange,gradient=true }) => {
  const [show, setShow] = useState(false);
  const target = useRef(null);

  return (
    <>
      {/* Trigger button with color preview */}
      <Button
        ref={target}
        variant="light"
        className="m-3"
        onClick={() => setShow(!show)}
        style={{
          border: "1px solid #ccc",
          background: value || "#ffffff",
          width: 36,
            height: 36,
        }}
      >
        <span
          className="roboto-grey fx-14"
        />
      </Button>

      {/* Popover with color picker */}
      <Overlay
        show={show}
        target={target.current}
        placement="auto"
        flip
        rootClose
        onHide={() => setShow(false)}
      >
        <Popover id="color-picker-popover">
          <Popover.Content style={{ padding: 0 }}>
            <div style={{ width: "fit-content", backgroundColor: "#fff", padding: 10 }}>
              <ColorPicker
                value={value}
                onChange={onChange}
                hideEyeDrop
                hideInputType
                hideGradient={!gradient}
              />
            </div>
          </Popover.Content>
        </Popover>
      </Overlay>
    </>
  );
};

export default PopoverColorPicker;
